<template>
  <div>
    <v-card class="mb-4" :loading="loading">
      <v-system-bar>Untentschuldigte Absenzen</v-system-bar>
      <AbsenceList
        :items="absencesUnexcused"
        hideStudent
        :schoolClass="student.schoolClass"
        :actions="['reactivate']"
        @updated="updated"
      />
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import AbsenceList from "common/components/AbsenceList.vue";

export default defineComponent({
  components: {
    AbsenceList,
  },
  props: {
    id: { type: Number, default: 0 },
    term: { startDate: 0 },
    student: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loadingAbsences: false,
      absencesUnexcused: [],
    };
  },
  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
    term() {
      this.fetchData();
    },
  },

  methods: {
    updated() {
      this.fetchData();
      this.$emit("updated");
    },
    async fetchData() {
      if (!this.id || !this.term) return;
      this.loading = true;

      this.absencesUnexcused = await this.apiList({
        resource: "absence/absence",
        query: `student=${this.id}&unexcused&term=${this.term.id}`,
      });

      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
